// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import MediaItemDetailViolation from '../search-data/mediaitem-detail-violation';
import MediaItemViolations from '../search-data/mediaitem-violations';
import Violations from '../search-data/violations';
import ViolationDetail from '../search-data/violation-detail';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Violations',
                        component: Violations,
                    },
                ],
            },
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Violation Detail',
                                component: ViolationDetail,
                            },
                        ],
                        weight: 150,
                    },
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Associated Media Item',
                                component: MediaItemDetailViolation,
                            },
                            {
                                type: 'tab',
                                name: 'Media Item Violations',
                                component: MediaItemViolations,
                            },
                        ],
                    },
                ],
            },
        ],
    },
};

function DashboardViolations() {
    return (
        <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="violations" version="1" />
    );
}

export default DashboardViolations;
